import { HttpMethod, HttpOption } from '@/utils/http-client'

export class ChannelAPIConstant {
    /**
     * 根据登录租户查询商户信息列表
     */
    QueryMerchantDropdownByUser = (data): HttpOption => ({
        url: '/front/merchantInfo/queryMerchantDropdownByUser',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询银行下拉列表
     */
    QueryAbroadBankDropdown = (data): HttpOption => ({
        url: '/front/abroadBank/queryAbroadBankDropdown',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询PayType 集合
     */
    QueryPayTypeList = (data): HttpOption => ({
        url: '/front/outComeRouteManage/queryPayTypeList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询paymentType 集合
     */
    QueryPaymentTypeList = (data): HttpOption => ({
        url: '/front/outComeRouteManage/queryPaymentTypeList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据情况查询paymentType 集合
     */
    QueryPaymentTypeListByScene = (data): HttpOption => ({
        url: '/front/outComeRouteManage/queryPaymentTypeListByScene',
        method: HttpMethod.POST,
        data
    })

    /**
     * 分页查询租户银行配置列表
     */
    BankMerchantList = (data): HttpOption => ({
        url: '/front/bankMerchant/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 复制租户银行配置列表（由一个租户的银行配置复制给另一个租户）
     */
    Copy = (data): HttpOption => ({
        url: '/front/bankMerchant/copy',
        method: HttpMethod.POST,
        data
    })

    /**
     * 添加租户银行配置
     */
    BankMerchantAdd = (data): HttpOption => ({
        url: '/front/bankMerchant/add',
        method: HttpMethod.POST,
        data
    })

    /**
     * 更新租户银行配置
     */
    BankMerchantUpdate = (data): HttpOption => ({
        url: '/front/bankMerchant/update',
        method: HttpMethod.POST,
        data
    })

    /**
     * 批量激活银行
     */
    BatchEnable = (data): HttpOption => ({
        url: '/front/abroadBank/batchEnable',
        method: HttpMethod.POST,
        data
    })

    /**
     * 批量禁止银行
     */
    BatchDisEnable = (data): HttpOption => ({
        url: '/front/abroadBank/batchProhibit',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据ID查询银行详情接口
     */
    QueryAbroadBankById = (data): HttpOption => ({
        url: '/front/abroadBank/queryAbroadBankById',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询租户下拉框
     */
    QueryMerchantDropdown = (data): HttpOption => ({
        url: '/front/merchantInfo/queryMerchantDropdown',
        method: HttpMethod.POST,
        data
    })

    /**
     * 查询商户-渠道信息列表
     */
    MerchantManageList = (data): HttpOption => ({
        url: '/front/merchantManage/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 添加商户信息接口
     */
    MerchantManageAdd = (data): HttpOption => ({
        url: '/front/merchantManage/add',
        method: HttpMethod.POST,
        data
    })

    /**
     * 修改商户信息接口
     */
    MerchantManageUpdate = (data): HttpOption => ({
        url: '/front/merchantManage/update',
        method: HttpMethod.POST,
        data
    })

    /**
     * 前端查询渠道列表下拉框
     */
    QueryChannelDropdown = (data): HttpOption => ({
        url: '/front/channel/queryChannelDropdown',
        method: HttpMethod.POST,
        data
    })

    /**
     * 根据条件分页查询渠道列表
     */
    ChannelList = (data): HttpOption => ({
        url: '/front/channel/channelList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 添加渠道
     */
    AddChannel = (data): HttpOption => ({
        url: '/front/channel/addChannel',
        method: HttpMethod.POST,
        data
    })

    /**
     * 编辑渠道
     */
    EditChannel = (data): HttpOption => ({
        url: '/front/channel/editChannel',
        method: HttpMethod.POST,
        data
    })

    /**
     * 获取三方参数列表
     */
    AbroadThirdParameterList = (data): HttpOption => ({
        url: '/front/abroadThirdParameter/getAbroadThirdParameterList',
        method: HttpMethod.POST,
        data
    })

    /**
     * 批量添加三方参数
     */
    AddAbroadThirdParameterBatch = (data): HttpOption => ({
        url: '/front/abroadThirdParameter/addAbroadThirdParameterBatch',
        method: HttpMethod.POST,
        data
    })

    /**
     * updateAbroadThirdParameter
     *
     */
    UpdateAbroadThirdParameter = (data): HttpOption => ({
        url: '/front/abroadThirdParameter/updateAbroadThirdParameter',
        method: HttpMethod.POST,
        data
    })

    /**
     * 删除三方参数
     *
     */
    DeleteAbroadThirdParameter = (data): HttpOption => ({
        url: '/front/abroadThirdParameter/deleteAbroadThirdParameter',
        method: HttpMethod.POST,
        data
    })

    /**
     * 条件分页查询路由对照列表
     */
    RouteControlList = (data): HttpOption => ({
        url: '/front/routeControl/list',
        method: HttpMethod.POST,
        data
    })

    /**
     * 添加路由对照
     */
    AddRouteControl = (data): HttpOption => ({
        url: '/front/routeControl/add',
        method: HttpMethod.POST,
        data
    })

    /**
     * 更新路由对照
     */
    UpdateRouteControl = (data): HttpOption => ({
        url: '/front/routeControl/update',
        method: HttpMethod.POST,
        data
    })
}
